import {api, routes} from "@/plugins/axios";

export function useSMSInbox() {

    const getSMSInbox = (organizationSlug, page = 1, perPage = 10, search = '', date = '', filter = '') => {
        return api.get(routes.smsInbox.get(organizationSlug, page, perPage, search, date, filter)).then((response) => {
            return Promise.resolve(response.data);
        }).catch((err) => {
            return Promise.reject(err);
        });
    }

    const updateSMS = (organizationSlug, smsUid, data) => {
        return api.put(routes.smsInbox.update(organizationSlug, smsUid), {
            read_at: new Date(),
            favorite: data.favorite,
        }).then((response) => {
            return Promise.resolve(response.data);
        }).catch((err) => {
            return Promise.reject(err);
        });
    }

    const deleteSMS = (organizationSlug, smsUid) => {
        return api.delete(routes.smsInbox.delete(organizationSlug, smsUid)).then((response) => {
            return Promise.resolve(response.data);
        }).catch((err) => {
            return Promise.reject(err);
        });
    }
    return {
        getSMSInbox,
        updateSMS,
        deleteSMS
    }
}
